import gql from 'graphql-tag';
import client from '../../client';
export const VALIDATE_VIP_COUPON = gql `
  mutation ValidateVipCouponMutation($input: CodeInput) {
    validateVipCoupon(input: $input) @rest(type: "ValidateVipCoupon", path: "admin/coupons/validations", method: "POST") {
      data {
        code
        valid
      }
      error {
        code
        message
      }
    }
  }
`;
export const validateVipCoupon = (code) => {
    return client.mutate({
        mutation: VALIDATE_VIP_COUPON,
        variables: {
            input: {
                code,
            },
        },
    });
};
export default validateVipCoupon;
